var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._l((_vm.images),function(image,i){return _c('img',{key:i,staticStyle:{"display":"none"},attrs:{"src":image},on:{"load":function($event){return _vm.loaded(i)}}})}),_vm._m(0)],2)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-graphic"},[_c('p',[_vm._v("LOADING")])])
}]

export { render, staticRenderFns }